import { Button, Form, Input, notification } from "antd";
import { API_URL } from "env";

const PermissionAddModal = ({ onClose }: { onClose: () => void }) => {
    const [form] = Form.useForm();
    const [api, contextHolder] = notification.useNotification();

    async function handleSubmit(values: { displayName: string; module: string; action: string; description: string }) {
        try {
            const response = await fetch(`${API_URL}api/v1/be/permissions`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${localStorage.getItem('token')}` },
                body: JSON.stringify({
                    display_name: values.displayName,
                    module: values.module,
                    action: values.action,
                    description: values.description,
                    is_active: true,
                }),
            });
            if (!response.ok) throw new Error('Network response was not ok');
            api.success({ message: 'Permission created', placement: 'topRight' });
            form.resetFields();
            onClose();
        } catch (error) {
            api.error({ message: 'Failed to create permission', placement: 'topRight' });
        }
    }

    return (
        <>
            {contextHolder}
            <Form form={form} layout="vertical" onFinish={handleSubmit}>
                <Form.Item name="displayName" label="Display Name" rules={[{ required: true, message: 'Required' }]}>
                    <Input placeholder="e.g. View Users" />
                </Form.Item>
                <div className="grid grid-cols-2 gap-4">
                    <Form.Item name="module" label="Module" rules={[{ required: true, message: 'Required' }]}>
                        <Input placeholder="e.g. users" />
                    </Form.Item>
                    <Form.Item name="action" label="Action" rules={[{ required: true, message: 'Required' }]}>
                        <Input placeholder="e.g. read" />
                    </Form.Item>
                </div>
                <Form.Item name="description" label="Description">
                    <Input.TextArea placeholder="Optional description" rows={3} />
                </Form.Item>
                <div className="flex justify-end gap-2 pt-2 border-t border-border">
                    <Button onClick={onClose}>Cancel</Button>
                    <Button type="primary" htmlType="submit">Create Permission</Button>
                </div>
            </Form>
        </>
    );
};

export default PermissionAddModal;
